// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
  },
}

;(function () {
  BoostPFS.inject(this)

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function () {
    var suggestionElement = this.$uiMenuElement
    var searchElement = this.$element
    var searchBoxId = this.id
  }

  // 	jQ('.search-button').on('click', function() {
  // 		setTimeout(function() {
  // 			jQ('.boost-pfs-search-suggestion-wrapper, .boost-pfs-search-suggestion-mobile-overlay, .boost-pfs-search-suggestion-mobile-top-panel').remove();
  // 			boostPFS.initSearchBox();
  // 		}, 500);
  // 	});

  InstantSearch.prototype.beforeInit = function () {
    jQ('#search-results').attr('style', 'display: none !important')
  }

  // Bind Event for input search Mobile
  var bindEventsMobile = InstantSearchMobile.prototype.bindEvents
  InstantSearchMobile.prototype.bindEvents = function () {
    bindEventsMobile.call(this)

    var self = this

    jQ('.site-nav--mobile .search-button')
      .off('click')
      .click(function (e) {
        e.preventDefault()
        //e.stopPropagation();
        jQ('.search-input-group input[type="search"]').focus()
        self.openSuggestionMobile()
        jQ('.drawer__close > button').trigger('click')
      })
  }

  // Bind Event for input search style 3
  var bindEvents = InstantSearchStyle3.prototype.bindEvents
  InstantSearchStyle3.prototype.bindEvents = function () {
    bindEvents.call(this)

    var self = this

    jQ('.site-header__links .search-button')
      .off('click')
      .click(function (e) {
        e.preventDefault()
        //e.stopPropagation();
        jQ('#SearchContainer #search-input').focus()
        self.openSuggestionStyle3()
        jQ('.drawer__close > button').trigger('click')
      })
  }

  InstantSearchResultItemProduct.prototype.compileTemplate = function () {
    if (this.isShow) {
      var searchTerm = Utils.stripHtml(Globals.currentTerm)
      // Product image
      var imageHTML = ''
      if (
        Settings.getSettingValue('search.showSuggestionProductImage') &&
        this.imageUrl.length
      ) {
        imageHTML = this.getTemplate(
          InstantSearchResultItemProduct.tempType.IMAGE
        )
        imageHTML = imageHTML.replace(/{{imageUrl}}/g, this.imageUrl)
      }
      // Product title
      var productTitle = this.customizeProductTitle()
      productTitle = this._highlightSuggestionResult(productTitle, searchTerm)

      // Product type
      var productType =
        '<p class="boost-pfs-search-suggestion-product-type">' +
        this.data.product_type +
        '</p>'

      // SKU
      var skuHTML = ''
      if (
        Settings.getSettingValue('search.showSuggestionProductSku') &&
        this.sku.length
      ) {
        skuHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.SKU)
        skuHTML = skuHTML.replace(/{{sku}}/g, this.sku)
      }
      // Vendor
      var vendorHTML = ''
      if (
        Settings.getSettingValue('search.showSuggestionProductVendor') &&
        this.vendor.length
      ) {
        vendorHTML = this.getTemplate(
          InstantSearchResultItemProduct.tempType.VENDOR
        )
        vendorHTML = vendorHTML.replace(/{{vendor}}/g, this.vendor)
      }
      // Price
      var priceHTML = this.compileSuggestionProductPrice()
      // Open the result item in new tab when selected
      var newTabAttr = Settings.getSettingValue('search.openProductNewTab')
        ? 'target="_blank"'
        : ''

      var itemHtml = `
					<li class="{{class.searchSuggestionItem}} {{class.searchSuggestionItem}}-product {{class.searchUiAutocompleteItem}}" aria-label="{{escapedBlockType}}: {{escapedTitle}}" data-id="{{id}}" role="option">
						<a tabindex="-1" href="{{url}}" {{newTabAttribute}}>
							{{itemProductImage}}
							<div class="{{class.searchSuggestion}}-right">
								<p class="{{class.searchSuggestion}}-product-title">{{title}}</p>
                                {{itemProductType}}
								{{itemProductSku}}
								{{itemProductVendor}}
								{{itemProductPrice}}
							</div>
						</a>
					</li>
				`.trim()

      return itemHtml
        .replace(/{{id}}/g, this.id)
        .replace(/{{escapedBlockType}}/g, Utils.stripHtml(this.parent.type))
        .replace(/{{url}}/g, this.url)
        .replace(/{{newTabAttribute}}/g, newTabAttr)
        .replace(/{{itemProductImage}}/g, imageHTML)
        .replace(/{{title}}/g, productTitle)
        .replace(/{{itemProductType}}/g, productType)
        .replace(/{{escapedTitle}}/g, Utils.stripHtml(productTitle))
        .replace(/{{itemProductSku}}/g, skuHTML)
        .replace(/{{itemProductVendor}}/g, vendorHTML)
        .replace(/{{itemProductPrice}}/, priceHTML)
        .replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion)
        .replace(/{{class.searchSuggestionItem}}/g, Class.searchSuggestionItem)
        .replace(
          /{{class.searchUiAutocompleteItem}}/g,
          Class.searchUiAutocompleteItem
        )
    } else {
      return ''
    }
  }
})()
